import { safeDefine } from "../../registration/safe-define.js";
import { MenuCheckboxItemElement } from "../../ui/menu/checkbox-item.js";
//#region src/define/ui/menu-checkbox-item.ts
safeDefine(MenuCheckboxItemElement);
//#endregion

//# sourceMappingURL=menu-checkbox-item.js.map